import { Link } from "react-router-dom";
import {
  Accordion,
  AccordionItem,
  AccordionTrigger,
  AccordionContent,
} from "./ui/accordion";
import { Reveal } from "./Reveal";
import { FAQS } from "../lib/data";

export default function FAQ() {
  return (
    <section
      className="bg-[#EAE7E0] py-24 md:py-40"
      data-testid="faq-section"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 grid grid-cols-1 md:grid-cols-12 gap-10 md:gap-16">
        <div className="md:col-span-4">
          <Reveal>
            <p className="font-sans text-xs tracking-[0.4em] uppercase text-[#7D8C7A] mb-6">
              Questions, answered
            </p>
            <h2 className="font-serif text-5xl md:text-6xl tracking-tight text-[#2C3C30] leading-[0.95]">
              Frequently asked
            </h2>
            <p className="font-sans text-[#566158] mt-6 leading-relaxed">
              Still unsure about something? Reach out — we&rsquo;re happy to
              help before you commit.
            </p>
            <Link
              to="/contact"
              data-testid="faq-contact-cta"
              className="inline-flex mt-8 items-center gap-3 rounded-full bg-[#2C3C30] px-7 py-3.5 text-[#F7F6F2] font-medium text-sm transition-colors duration-300 hover:bg-[#1A211D]"
            >
              Ask a question
            </Link>
          </Reveal>
        </div>

        <div className="md:col-span-7 md:col-start-6">
          <Reveal delay={0.1}>
            <Accordion type="single" collapsible className="w-full" data-testid="faq-accordion">
              {FAQS.map((item, i) => (
                <AccordionItem
                  key={i}
                  value={`item-${i}`}
                  className="border-b border-[#2C3C30]/15"
                  data-testid={`faq-item-${i}`}
                >
                  <AccordionTrigger className="font-serif text-xl md:text-2xl text-[#2C3C30] tracking-tight py-6 hover:no-underline [&>svg]:text-[#7D8C7A] [&>svg]:h-5 [&>svg]:w-5">
                    {item.q}
                  </AccordionTrigger>
                  <AccordionContent className="font-sans text-base text-[#566158] leading-relaxed pb-6 pr-6">
                    {item.a}
                  </AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
